import React, { useState } from 'react'

const TabDescription = ({ data }) => {
  const [open, setOpen] = useState(false)

  const renderSpecs = () => {
    const arr = []
    if (data.sku) {
      arr.unshift(
        <tr>
          <td>
            <strong>SKU:</strong> {data.sku}
          </td>
        </tr>
      )
    }
    if (data.human_consumption !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Human Consumption:</strong> {data.human_consumption ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.manufacturer) {
      arr.unshift(
        <tr>
          <td>
            <strong>Manufacturer:</strong> {data.manufacturer}
          </td>
        </tr>
      )
    }
    if (data.aerosol !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Aerosol:</strong> {data.aerosol ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.warning) {
      arr.unshift(
        <tr>
          <td>
            <strong>Warning:</strong> {data.warning}
          </td>
        </tr>
      )
    }
    if (data.country_of_origin) {
      arr.unshift(
        <tr>
          <td>
            <strong>Country of Origin - Textiles:</strong> {data.country_of_origin}
          </td>
        </tr>
      )
    }
    if (data.antitarnish !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Antitarnish:</strong> {data.antitarnish ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.controlled_substance) {
      arr.unshift(
        <tr>
          <td>
            <strong>Controlled Substance:</strong> {data.controlled_substance}
          </td>
        </tr>
      )
    }
    if (data.requires_textile_labeling !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Requires Textile Act Labeling:</strong> {data.requires_textile_labeling ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.adult_product !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Adult Product:</strong> {data.adult_product ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.active_ingredient) {
      arr.unshift(
        <tr>
          <td>
            <strong>Active Ingredient:</strong> {data.active_ingredient}
          </td>
        </tr>
      )
    }
    if (data.active_ingredients) {
      arr.unshift(
        <tr>
          <td>
            <strong>Active Ingredients:</strong> {data.active_ingredients}
          </td>
        </tr>
      )
    }
    if (data.active_ingredient_name) {
      arr.unshift(
        <tr>
          <td>
            <strong>Active Ingredient Name:</strong> {data.active_ingredient_name}
          </td>
        </tr>
      )
    }
    if (data.inactive_ingredients) {
      arr.unshift(
        <tr>
          <td>
            <strong>Inactive Ingredients:</strong> {data.inactive_ingredients}
          </td>
        </tr>
      )
    }
    if (data.latex_free !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Latex Free:</strong> {data.latex_free ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.health_concerns) {
      arr.unshift(
        <tr>
          <td>
            <strong>Health Concerns:</strong> {data.health_concerns}
          </td>
        </tr>
      )
    }
    if (data.combustible !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Combustible:</strong> {data.combustible ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.flammable !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Flammable:</strong> {data.flammable ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.recycled_material) {
      arr.unshift(
        <tr>
          <td>
            <strong>Made From Recycled Material:</strong> {data.recycled_material}
          </td>
        </tr>
      )
    }
    if (data.foldable !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Foldable:</strong> {data.foldable ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.number_of_sheets) {
      arr.unshift(
        <tr>
          <td>
            <strong>Number of Sheets:</strong> {data.number_of_sheets}
          </td>
        </tr>
      )
    }
    if (data.refillable !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Refillable:</strong> {data.refillable ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data['Number of Sheets']) {
      arr.unshift(
        <tr>
          <td>
            <strong>number_of_sheets:</strong> {data.number_of_sheets}
          </td>
        </tr>
      )
    }
    if (data.envelope_size) {
      arr.unshift(
        <tr>
          <td>
            <strong>Envelope Size:</strong> {data.envelope_size}
          </td>
        </tr>
      )
    }
    if (data.calendar_format) {
      arr.unshift(
        <tr>
          <td>
            <strong>Calendar Format:</strong> {data.calendar_format}
          </td>
        </tr>
      )
    }
    if (data.year) {
      arr.unshift(
        <tr>
          <td>
            <strong>Year:</strong> {data.year}
          </td>
        </tr>
      )
    }
    if (data.skill_level) {
      arr.unshift(
        <tr>
          <td>
            <strong>Skill Level:</strong> {data.skill_level}
          </td>
        </tr>
      )
    }
    if (data.chain_length) {
      arr.unshift(
        <tr>
          <td>
            <strong>Chain Length:</strong> {data.chain_length}
          </td>
        </tr>
      )
    }
    if (data.compatible_devices) {
      arr.unshift(
        <tr>
          <td>
            <strong>Compatible Devices:</strong> {data.compatible_devices}
          </td>
        </tr>
      )
    }
    if (data['skill-level']) {
      arr.unshift(
        <tr>
          <td>
            <strong>Skill Level:</strong> {data.skill_level}
          </td>
        </tr>
      )
    }
    if (data.weather_resistant !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Weather Resistant:</strong> {data.weather_resistant ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.self_adhesive !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Self Adhesive:</strong> {data.self_adhesive ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.handle_length) {
      arr.unshift(
        <tr>
          <td>
            <strong>Handle Length:</strong> {data.handle_length}
          </td>
        </tr>
      )
    }
    if (data.fine_or_fashion) {
      arr.unshift(
        <tr>
          <td>
            <strong>Fine or Fashion:</strong> {data.fine_or_fashion}
          </td>
        </tr>
      )
    }
    if (data.brightness) {
      arr.unshift(
        <tr>
          <td>
            <strong>Brightness:</strong> {data.brightness}
          </td>
        </tr>
      )
    }
    if (data.is_reflective !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Is Reflective:</strong> {data.is_reflective ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.blade_width) {
      arr.unshift(
        <tr>
          <td>
            <strong>Blade Width:</strong> {data.blade_width}
          </td>
        </tr>
      )
    }
    if (data.metal_stamp) {
      arr.unshift(
        <tr>
          <td>
            <strong>Metal Stamp:</strong> {data.metal_stamp}
          </td>
        </tr>
      )
    }
    if (data.gold_purity_karats) {
      arr.unshift(
        <tr>
          <td>
            <strong>Gold Purity - Karats:</strong> {data.gold_purity_karats}
          </td>
        </tr>
      )
    }
    if (data.industrial !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Industrial:</strong> {data.industrial ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.birthstone) {
      arr.unshift(
        <tr>
          <td>
            <strong>Birthstone:</strong> {data.birthstone}
          </td>
        </tr>
      )
    }
    if (data.clasp_type) {
      arr.unshift(
        <tr>
          <td>
            <strong>Clasp Type:</strong> {data.clasp_type}
          </td>
        </tr>
      )
    }
    if (data.back_finding) {
      arr.unshift(
        <tr>
          <td>
            <strong>Back Finding:</strong> {data.back_finding}
          </td>
        </tr>
      )
    }
    if (data.jewelry_setting) {
      arr.unshift(
        <tr>
          <td>
            <strong>Jewelry Setting:</strong> {data.jewelry_setting}
          </td>
        </tr>
      )
    }
    if (data.earring_style) {
      arr.unshift(
        <tr>
          <td>
            <strong>Earring Style:</strong> {data.earring_style}
          </td>
        </tr>
      )
    }
    if (data.earring_feature) {
      arr.unshift(
        <tr>
          <td>
            <strong>Earring Feature:</strong> {data.earring_feature}
          </td>
        </tr>
      )
    }
    if (data.bracelet_feature) {
      arr.unshift(
        <tr>
          <td>
            <strong>Bracelet Style:</strong> {data.bracelet_feature}
          </td>
        </tr>
      )
    }
    if (data.cable_length) {
      arr.unshift(
        <tr>
          <td>
            <strong>Cable Length:</strong> {data.cable_length}
          </td>
        </tr>
      )
    }
    if (data.roll_length) {
      arr.unshift(
        <tr>
          <td>
            <strong>Roll Length:</strong> {data.roll_length}
          </td>
        </tr>
      )
    }
    if (data.necklace_style) {
      arr.unshift(
        <tr>
          <td>
            <strong>Necklace Style:</strong> {data.necklace_style}
          </td>
        </tr>
      )
    }
    if (data.model_name) {
      arr.unshift(
        <tr>
          <td>
            <strong>Model Name:</strong> {data.model_name}
          </td>
        </tr>
      )
    }
    if (data.chain_pattern) {
      arr.unshift(
        <tr>
          <td>
            <strong>Chain Pattern:</strong> {data.chain_pattern}
          </td>
        </tr>
      )
    }
    if (data.downloadable_content !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Downloadable Content:</strong> {data.downloadable_content ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.gemstone) {
      arr.unshift(
        <tr>
          <td>
            <strong>Gemstone:</strong> {data.gemstone}
          </td>
        </tr>
      )
    }
    if (data.input_output_type) {
      arr.unshift(
        <tr>
          <td>
            <strong>Input/Output Type:</strong> {data.input_output_type}
          </td>
        </tr>
      )
    }
    if (data.pearl_type) {
      arr.unshift(
        <tr>
          <td>
            <strong>Pearl Type:</strong> {data.pearl_type}
          </td>
        </tr>
      )
    }
    if (data.inscription) {
      arr.unshift(
        <tr>
          <td>
            <strong>Inscription:</strong> {data.inscription}
          </td>
        </tr>
      )
    }
    if (data.wireless_technologies) {
      arr.unshift(
        <tr>
          <td>
            <strong>Wireless Technologies:</strong> {data.wireless_technologies}
          </td>
        </tr>
      )
    }
    if (data.input_output_quantity) {
      arr.unshift(
        <tr>
          <td>
            <strong>Input/Output Quantity:</strong> {data.input_output_quantity}
          </td>
        </tr>
      )
    }
    if (data.has_integrated_speakers !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Has Integrated Speakers:</strong> {data.has_integrated_speakers ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.resizable !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Resizable:</strong> {data.resizable ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.ring_size) {
      arr.unshift(
        <tr>
          <td>
            <strong>Ring Size:</strong> {data.ring_size}
          </td>
        </tr>
      )
    }
    if (data.memory_card_format) {
      arr.unshift(
        <tr>
          <td>
            <strong>Memory Card Format:</strong> {data.memory_card_format}
          </td>
        </tr>
      )
    }
    if (data.headphone_features) {
      arr.unshift(
        <tr>
          <td>
            <strong>Headphone Features:</strong> {data.headphone_features}
          </td>
        </tr>
      )
    }
    if (data.circumference) {
      arr.unshift(
        <tr>
          <td>
            <strong>Circumference:</strong> {data.circumference}
          </td>
        </tr>
      )
    }
    if (data.audio_features) {
      arr.unshift(
        <tr>
          <td>
            <strong>Audio Features:</strong> {data.audio_features}
          </td>
        </tr>
      )
    }
    if (data.diameter) {
      arr.unshift(
        <tr>
          <td>
            <strong>Diameter:</strong> {data.diameter}
          </td>
        </tr>
      )
    }
    if (data.number_of_speakers) {
      arr.unshift(
        <tr>
          <td>
            <strong>Number of Speakers:</strong> {data.number_of_speakers}
          </td>
        </tr>
      )
    }
    if (data.rated_for_outdoor_use !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Rated For Outdoor Use:</strong> {data.rated_for_outdoor_use ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.body_part) {
      arr.unshift(
        <tr>
          <td>
            <strong>Body Part:</strong> {data.body_part}
          </td>
        </tr>
      )
    }
    if (data.cordless !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Cordless:</strong> {data.cordless ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.battery_life) {
      arr.unshift(
        <tr>
          <td>
            <strong>Battery Life:</strong> {data.battery_life}
          </td>
        </tr>
      )
    }
    if (data.lifespan) {
      arr.unshift(
        <tr>
          <td>
            <strong>Lifespan:</strong> {data.lifespan}
          </td>
        </tr>
      )
    }
    if (data.cord_length) {
      arr.unshift(
        <tr>
          <td>
            <strong>Cord Length:</strong> {data.cord_length}
          </td>
        </tr>
      )
    }
    if (data.feeding_instructions) {
      arr.unshift(
        <tr>
          <td>
            <strong>Feeding Instructions:</strong> {data.feeding_instructions}
          </td>
        </tr>
      )
    }
    if (data.feedinplant_categoryg_instructions) {
      arr.unshift(
        <tr>
          <td>
            <strong>Plant Category:</strong> {data.plant_category}
          </td>
        </tr>
      )
    }
    if (data.pet_food_form) {
      arr.unshift(
        <tr>
          <td>
            <strong>Pet Food Form:</strong> {data.pet_food_form}
          </td>
        </tr>
      )
    }
    if (data.paper_size) {
      arr.unshift(
        <tr>
          <td>
            <strong>Paper Size:</strong> {data.paper_size}
          </td>
        </tr>
      )
    }
    if (data.plant_category) {
      arr.unshift(
        <tr>
          <td>
            <strong>Plant Category:</strong> {data.plant_category}
          </td>
        </tr>
      )
    }
    if (data.capacity) {
      arr.unshift(
        <tr>
          <td>
            <strong>Capacity:</strong> {data.capacity}
          </td>
        </tr>
      )
    }
    if (data.fluid_ounces) {
      arr.unshift(
        <tr>
          <td>
            <strong>Fluid Ounces:</strong> {data.fluid_ounces}
          </td>
        </tr>
      )
    }
    if (data.volume_capacity) {
      arr.unshift(
        <tr>
          <td>
            <strong>Volume Capacity:</strong> {data.volume_capacity}
          </td>
        </tr>
      )
    }
    if (data.count) {
      arr.unshift(
        <tr>
          <td>
            <strong>Count:</strong> {data.count}
          </td>
        </tr>
      )
    }
    if (data.animal_health_concern) {
      arr.unshift(
        <tr>
          <td>
            <strong>Animal Health Concern:</strong> {data.animal_health_concern}
          </td>
        </tr>
      )
    }
    if (data.waterproof !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Waterproof:</strong> {data.waterproof ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.animal_weight) {
      arr.unshift(
        <tr>
          <td>
            <strong>Animal Weight:</strong> {data.animal_weight}
          </td>
        </tr>
      )
    }
    if (data.pet_size) {
      arr.unshift(
        <tr>
          <td>
            <strong>Pet Size:</strong> {data.pet_size}
          </td>
        </tr>
      )
    }
    if (data.flavor) {
      arr.unshift(
        <tr>
          <td>
            <strong>Flavor:</strong> {data.flavor}
          </td>
        </tr>
      )
    }
    if (data.animal_lifestage) {
      arr.unshift(
        <tr>
          <td>
            <strong>Animal Lifestage:</strong> {data.animal_lifestage}
          </td>
        </tr>
      )
    }
    if (data.nutrient) {
      arr.unshift(
        <tr>
          <td>
            <strong>Nutrient:</strong> {data.nutrient}
          </td>
        </tr>
      )
    }
    if (data.serving_size) {
      arr.unshift(
        <tr>
          <td>
            <strong>Serving Size:</strong> {data.serving_size}
          </td>
        </tr>
      )
    }
    if (data.ingredients) {
      arr.unshift(
        <tr>
          <td>
            <strong>Ingredients:</strong> {data.ingredients}
          </td>
        </tr>
      )
    }
    if (data.has_gmos !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Has GMOs:</strong> {data.has_gmos ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.ready_to_eat !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Ready To Eat:</strong> {data.ready_to_eat ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.temperature_sensitive !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Temperature Sensitive:</strong> {data.temperature_sensitive ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.require_nutrition_facts !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Require Nutrition Facts:</strong> {data.require_nutrition_facts ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.perishable !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Perishable:</strong> {data.perishable ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.alcohol_content_by_volume) {
      arr.unshift(
        <tr>
          <td>
            <strong>Alcohol Content by Volume:</strong> {data.alcohol_content_by_volume}
          </td>
        </tr>
      )
    }
    if (data.makes_noise !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Makes Noise:</strong> {data.makes_noise ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.alcohol_proof) {
      arr.unshift(
        <tr>
          <td>
            <strong>Alcohol Proof:</strong> {data.alcohol_proof}
          </td>
        </tr>
      )
    }
    if (data.fabric_content) {
      arr.unshift(
        <tr>
          <td>
            <strong>Fabric Content:</strong> {data.fabric_content}
          </td>
        </tr>
      )
    }
    if (data.fabric_care_instructions) {
      arr.unshift(
        <tr>
          <td>
            <strong>Fabric Care Instructions:</strong> {data.fabric_care_instructions}
          </td>
        </tr>
      )
    }
    if (data.cleaning_care_maintenance) {
      arr.unshift(
        <tr>
          <td>
            <strong>Cleaning, Care & Maintenance:</strong> {data.cleaning_care_maintenance}
          </td>
        </tr>
      )
    }
    if (data.alcohol_class_type) {
      arr.unshift(
        <tr>
          <td>
            <strong>Alcohol Class & Type:</strong> {data.alcohol_class_type}
          </td>
        </tr>
      )
    }
    if (data.neutral_spirits_coloring) {
      arr.unshift(
        <tr>
          <td>
            <strong>Neutral Spirits Coloring & Flavoring:</strong> {data.neutral_spirits_coloring}
          </td>
        </tr>
      )
    }
    if (data.wine_varietal) {
      arr.unshift(
        <tr>
          <td>
            <strong>Wine Varietal:</strong> {data.wine_varietal}
          </td>
        </tr>
      )
    }
    if (data.container_type) {
      arr.unshift(
        <tr>
          <td>
            <strong>Container Type:</strong> {data.container_type}
          </td>
        </tr>
      )
    }
    if (data.material) {
      arr.unshift(
        <tr>
          <td>
            <strong>Material:</strong> {data.material}
          </td>
        </tr>
      )
    }
    if (data.servings_per_container) {
      arr.unshift(
        <tr>
          <td>
            <strong>Servings Per Container:</strong> {data.servings_per_container}
          </td>
        </tr>
      )
    }
    if (data.calories_per_serving) {
      arr.unshift(
        <tr>
          <td>
            <strong>Calories Per Serving:</strong> {data.calories_per_serving}
          </td>
        </tr>
      )
    }
    if (data.fat_calories_per_serving) {
      arr.unshift(
        <tr>
          <td>
            <strong>Fat Calories Per Serving:</strong> {data.fat_calories_per_serving}
          </td>
        </tr>
      )
    }
    if (data.total_fat_per_serving) {
      arr.unshift(
        <tr>
          <td>
            <strong>Total Fat Per Serving:</strong> {data.total_fat_per_serving}
          </td>
        </tr>
      )
    }
    if (data.total_fat_percentage_daily) {
      arr.unshift(
        <tr>
          <td>
            <strong>Total Fat Percentage Daily Value:</strong> {data.total_fat_percentage_daily}
          </td>
        </tr>
      )
    }
    if (data.plating) {
      arr.unshift(
        <tr>
          <td>
            <strong>Plating:</strong> {data.plating}
          </td>
        </tr>
      )
    }
    if (data.fat_calories_per_gram) {
      arr.unshift(
        <tr>
          <td>
            <strong>Fat Calories Per Gram:</strong> {data.fat_calories_per_gram}
          </td>
        </tr>
      )
    }
    if (data.total_carbohydrate) {
      arr.unshift(
        <tr>
          <td>
            <strong>Total Carbohydrate:</strong> {data.total_carbohydrate}
          </td>
        </tr>
      )
    }
    if (data.total_carbohydrate_daily) {
      arr.unshift(
        <tr>
          <td>
            <strong>Total Carbohydrate Percentage Daily Value:</strong> {data.total_carbohydrate_daily}
          </td>
        </tr>
      )
    }
    if (data.carbohydrate_calories_gram) {
      arr.unshift(
        <tr>
          <td>
            <strong>Carbohydrate Calories Per Gram:</strong> {data.carbohydrate_calories_gram}
          </td>
        </tr>
      )
    }
    if (data.watts) {
      arr.unshift(
        <tr>
          <td>
            <strong>Watts:</strong> {data.watts}
          </td>
        </tr>
      )
    }
    if (data.light_bulb_color) {
      arr.unshift(
        <tr>
          <td>
            <strong>Light Bulb Color:</strong> {data.light_bulb_color}
          </td>
        </tr>
      )
    }
    if (data.number_of_lights) {
      arr.unshift(
        <tr>
          <td>
            <strong>Number of Lights:</strong> {data.number_of_lights}
          </td>
        </tr>
      )
    }
    if (data.light_bulb_type) {
      arr.unshift(
        <tr>
          <td>
            <strong>Light Bulb Type:</strong> {data.light_bulb_type}
          </td>
        </tr>
      )
    }
    if (data.nutrient_footnote) {
      arr.unshift(
        <tr>
          <td>
            <strong>Nutrient Footnote:</strong> {data.nutrient_footnote}
          </td>
        </tr>
      )
    }
    if (data.light_bulb_shape) {
      arr.unshift(
        <tr>
          <td>
            <strong>Light Bulb Shape:</strong> {data.light_bulb_shape}
          </td>
        </tr>
      )
    }
    if (data.nutrients) {
      arr.unshift(
        <tr>
          <td>
            <strong>Nutrients:</strong> {data.nutrients}
          </td>
        </tr>
      )
    }
    if (data.protein_calories_gram) {
      arr.unshift(
        <tr>
          <td>
            <strong>Protein Calories Per Gram:</strong> {data.protein_calories_gram}
          </td>
        </tr>
      )
    }
    if (data.light_bulb_base_code) {
      arr.unshift(
        <tr>
          <td>
            <strong>Light Bulb Base Code:</strong> {data.light_bulb_base_code}
          </td>
        </tr>
      )
    }
    if (data.total_protein_daily) {
      arr.unshift(
        <tr>
          <td>
            <strong>Total Protein Percentage Daily Value:</strong> {data.total_protein_daily}
          </td>
        </tr>
      )
    }
    if (data.has_cfl !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Has CFL:</strong> {data.has_cfl ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.total_protein_serving) {
      arr.unshift(
        <tr>
          <td>
            <strong>Total Protein Per Serving:</strong> {data.total_protein_serving}
          </td>
        </tr>
      )
    }
    if (data.food_form) {
      arr.unshift(
        <tr>
          <td>
            <strong>Food Form:</strong> {data.food_form}
          </td>
        </tr>
      )
    }
    if (data.imitation !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Imitation:</strong> {data.imitation ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.metal) {
      arr.unshift(
        <tr>
          <td>
            <strong>Metal:</strong> {data.metal}
          </td>
        </tr>
      )
    }
    if (data.inflatable !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Inflatable:</strong> {data.inflatable ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.usda_inspected !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>USDA Inspected:</strong> {data.usda_inspected ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.bed_size) {
      arr.unshift(
        <tr>
          <td>
            <strong>Bed Size:</strong> {data.bed_size}
          </td>
        </tr>
      )
    }
    if (data.diaper_size) {
      arr.unshift(
        <tr>
          <td>
            <strong>Diaper Size:</strong> {data.diaper_size}
          </td>
        </tr>
      )
    }
    if (data.high_fructose_corn_syrup !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Has High Fructose Corn Syrup:</strong> {data.high_fructose_corn_syrup ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.baby_diaper_category) {
      arr.unshift(
        <tr>
          <td>
            <strong>Disposable Baby Diaper Category:</strong> {data.baby_diaper_category}
          </td>
        </tr>
      )
    }
    if (data.allergens) {
      arr.unshift(
        <tr>
          <td>
            <strong>Allergens:</strong> {data.allergens}
          </td>
        </tr>
      )
    }
    if (data.caffeine_designation) {
      arr.unshift(
        <tr>
          <td>
            <strong>Caffeine Designation:</strong> {data.caffeine_designation}
          </td>
        </tr>
      )
    }
    if (data.spice_level) {
      arr.unshift(
        <tr>
          <td>
            <strong>Spice Level:</strong> {data.spice_level}
          </td>
        </tr>
      )
    }
    if (data.healthy_incentive !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Healthy Incentive:</strong> {data.healthy_incentive ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.snap_eligible !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>SNAP Eligible:</strong> {data.snap_eligible ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.wic_eligible !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>WIC Eligible:</strong> {data.wic_eligible ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.pattern) {
      arr.unshift(
        <tr>
          <td>
            <strong>Pattern:</strong> {data.pattern}
          </td>
        </tr>
      )
    }
    if (data.cuisine) {
      arr.unshift(
        <tr>
          <td>
            <strong>Cuisine:</strong> {data.cuisine}
          </td>
        </tr>
      )
    }
    if (data.food_preparation_tips) {
      arr.unshift(
        <tr>
          <td>
            <strong>Food Preparation Tips:</strong> {data.food_preparation_tips}
          </td>
        </tr>
      )
    }
    if (data.food_storage_tips) {
      arr.unshift(
        <tr>
          <td>
            <strong>Food Storage Tips:</strong> {data.food_storage_tips}
          </td>
        </tr>
      )
    }
    if (data.educational_focus) {
      arr.unshift(
        <tr>
          <td>
            <strong>Educational Focus:</strong> {data.educational_focus}
          </td>
        </tr>
      )
    }
    if (data.count_per_pack) {
      arr.unshift(
        <tr>
          <td>
            <strong>Count Per Pack:</strong> {data.count_per_pack}
          </td>
        </tr>
      )
    }
    if (data.multipack_quantity) {
      arr.unshift(
        <tr>
          <td>
            <strong>Multipack Quantity:</strong> {data.multipack_quantity}
          </td>
        </tr>
      )
    }
    if (data.number_players) {
      arr.unshift(
        <tr>
          <td>
            <strong>Number of Players:</strong> {data.number_players}
          </td>
        </tr>
      )
    }
    if (data.total_count) {
      arr.unshift(
        <tr>
          <td>
            <strong>Total Count:</strong> {data.total_count}
          </td>
        </tr>
      )
    }
    if (data.number_of_pieces) {
      arr.unshift(
        <tr>
          <td>
            <strong>Number of Pieces:</strong> {data.number_of_pieces}
          </td>
        </tr>
      )
    }
    if (data.set !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Set:</strong> {data.set ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.dosage) {
      arr.unshift(
        <tr>
          <td>
            <strong>Dosage:</strong> {data.dosage}
          </td>
        </tr>
      )
    }
    if (data.stop_use_indications) {
      arr.unshift(
        <tr>
          <td>
            <strong>Stop Use Indications:</strong> {data.stop_use_indications}
          </td>
        </tr>
      )
    }
    if (data.volts) {
      arr.unshift(
        <tr>
          <td>
            <strong>Volts:</strong> {data.volts}
          </td>
        </tr>
      )
    }
    if (data.energy_star_certified !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Energy Star Certified:</strong> {data.energy_star_certified ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.connector_type) {
      arr.unshift(
        <tr>
          <td>
            <strong>Energy Star-Connector Type:</strong> {data.connector_type}
          </td>
        </tr>
      )
    }
    if (data.disposable !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Disposable:</strong> {data.disposable ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.recommended_surfaces) {
      arr.unshift(
        <tr>
          <td>
            <strong>Recommended Surfaces:</strong> {data.recommended_surfaces}
          </td>
        </tr>
      )
    }
    if (data.form) {
      arr.unshift(
        <tr>
          <td>
            <strong>Form:</strong> {data.form}
          </td>
        </tr>
      )
    }
    if (data.instructions) {
      arr.unshift(
        <tr>
          <td>
            <strong>Instructions:</strong> {data.instructions}
          </td>
        </tr>
      )
    }
    if (data.assembly_required !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Assembly Required:</strong> {data.assembly_required ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.fill_material) {
      arr.unshift(
        <tr>
          <td>
            <strong>Fill Material:</strong> {data.fill_material}
          </td>
        </tr>
      )
    }
    if (data.drawers) {
      arr.unshift(
        <tr>
          <td>
            <strong>Drawers:</strong> {data.drawers}
          </td>
        </tr>
      )
    }
    if (data.rug_size) {
      arr.unshift(
        <tr>
          <td>
            <strong>Rug Size:</strong> {data.rug_size}
          </td>
        </tr>
      )
    }
    if (data.bristle_material) {
      arr.unshift(
        <tr>
          <td>
            <strong>Bristle Material:</strong> {data.bristle_material}
          </td>
        </tr>
      )
    }
    if (data.curtain_panel_style) {
      arr.unshift(
        <tr>
          <td>
            <strong>Curtain Panel Style:</strong> {data.curtain_panel_style}
          </td>
        </tr>
      )
    }
    if (data.travel_size !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Travel Size:</strong> {data.travel_size ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.retractable !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Retractable:</strong> {data.retractable ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.skin_care_concern) {
      arr.unshift(
        <tr>
          <td>
            <strong>Skin Care Concern:</strong> {data.skin_care_concern}
          </td>
        </tr>
      )
    }
    if (data.skin_tone) {
      arr.unshift(
        <tr>
          <td>
            <strong>Skin Tone:</strong> {data.skin_tone}
          </td>
        </tr>
      )
    }
    if (data.portable !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Portable:</strong> {data.portable ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    if (data.finish) {
      arr.unshift(
        <tr>
          <td>
            <strong>Finish:</strong> {data.finish}
          </td>
        </tr>
      )
    }
    if (data.scent) {
      arr.unshift(
        <tr>
          <td>
            <strong>Scent:</strong> {data.scent}
          </td>
        </tr>
      )
    }
    if (data.powered) {
      arr.unshift(
        <tr>
          <td>
            <strong>Powered:</strong> {data.powered}
          </td>
        </tr>
      )
    }
    if (data.battery_required) {
      arr.unshift(
        <tr>
          <td>
            <strong>Batteries Required:</strong> {data.battery_required}
          </td>
        </tr>
      )
    }
    if (data.assembled_product_weight) {
      arr.unshift(
        <tr>
          <td>
            <strong>Assembled Product Weight:</strong> {data.assembled_product_weight}
          </td>
        </tr>
      )
    }
    if (data.contains_batteries) {
      arr.unshift(
        <tr>
          <td>
            <strong>Contains Batteries:</strong> {data.contains_batteries}
          </td>
        </tr>
      )
    }
    if (data.assembled_product_length) {
      arr.unshift(
        <tr>
          <td>
            <strong>Assembled Product Length:</strong> {data.assembled_product_length}
          </td>
        </tr>
      )
    }
    if (data.assembled_product_width) {
      arr.unshift(
        <tr>
          <td>
            <strong>Assembled Product Width:</strong> {data.assembled_product_width}
          </td>
        </tr>
      )
    }
    if (data.assembled_product_height) {
      arr.unshift(
        <tr>
          <td>
            <strong>Assembled Product Height:</strong> {data.assembled_product_height}
          </td>
        </tr>
      )
    }
    if (data.size) {
      arr.unshift(
        <tr>
          <td>
            <strong>Size:</strong> {data.size}
          </td>
        </tr>
      )
    }
    if (data.age_range) {
      arr.unshift(
        <tr>
          <td>
            <strong>Age Range:</strong> {data.age_range}
          </td>
        </tr>
      )
    }
    if (data.age_group) {
      arr.unshift(
        <tr>
          <td>
            <strong>Age Group:</strong> {data.age_group}
          </td>
        </tr>
      )
    }
    if (data.brand) {
      arr.unshift(
        <tr>
          <td>
            <strong>Brand:</strong> {data.brand}
          </td>
        </tr>
      )
    }
    if (data.color) {
      arr.unshift(
        <tr>
          <td>
            <strong>Color:</strong> {data.color}
          </td>
        </tr>
      )
    }
    if (data.key_features) {
      arr.unshift(
        <tr>
          <td>
            <strong>Key Features:</strong> {data.key_features}
          </td>
        </tr>
      )
    }
    if (data.biodegradable !== null) {
      arr.unshift(
        <tr>
          <td>
            <strong>Biodegradable:</strong> {data.biodegradable ? 'yes' : 'no'}
          </td>
        </tr>
      )
    }
    const rowsWithKeys = arr.map((item, index) => React.cloneElement(item, { key: `row-${index}` }))
    return rowsWithKeys
  }

  return (
    <div className='tab-description'>
      <div className={`tab-description__body tab-description__body--${open ? 'open' : 'closed'}`} id="product-highlights">
        <div className="tab-description__section" >
          <p>Highlights</p>
          <ul>
            {data && data.highlight1 && <li>{data.highlight1}</li>}
            {data && data.highlight2 && <li>{data.highlight2}</li>}
            {data && data.highlight3 && <li>{data.highlight3}</li>}
            {data && data.highlight4 && <li>{data.highlight4}</li>}
          </ul>
        </div>
        <div className="tab-description__section" id="product-description">
          <p>Description</p>
          <p dangerouslySetInnerHTML={{ __html: data && data.description }}></p>
        </div>
        <div className="tab-description__section" id="product-specs">
          <table aria-labelledby='product-specs'>
            <thead><tr><th>Specifications</th></tr></thead>
            <tbody>
            {renderSpecs()}
            </tbody>
          </table>
        </div>
      </div>
      <div className="tab-description__show-more-less-button">
        <button
          aria-expanded={open}
          className="btn__secondary btn__secondary--full"
          onClick={() => {
            setOpen(!open)
          }}
        >
          {!open ? 'SHOW MORE' : 'SHOW LESS'}
        </button>
      </div>
    </div>
  )
}

export default TabDescription
